/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */

import * as React from "react";
import { LocalizationInfo } from "@emt/emt-localization/lib/localization-info";
import { LocalizationContext } from "../context/LocalizationContext";
import { Header, IndeterminateProgressBar, FullRow } from "@emt/emt-react";
import { EnrollmentDetail } from "../containers/base-container";
import { userLocale } from "@emt/emt-localization/lib/user-locale";

// TODO: Revert back the change.
const dateOnlyOptions = {
  year: undefined,
  month: undefined,
  day: undefined,
};

export class OfferingPageProperties {
  fetchedData: boolean = false;
  enrollments: EnrollmentDetail[] = [];
  error: boolean = false;
}

export class OfferingPageRouteProperties {
  offeringId: string;
}

export class OfferingPageState {
  offeringId: string;
  chosenLocationIndex: number;
}

export class OfferingPage extends React.Component<
  OfferingPageProperties & OfferingPageRouteProperties,
  OfferingPageState
> {
  constructor(props: OfferingPageProperties & OfferingPageRouteProperties) {
    super(props);
    this.state = {
      offeringId: props.offeringId,
      chosenLocationIndex: 0,
    };
  }

  render(): JSX.Element {
    return (
      <LocalizationContext.Consumer>
        {(localization) => this.renderContent(localization)}
      </LocalizationContext.Consumer>
    );
  }

  renderContent(localization: LocalizationInfo): JSX.Element {
    var allLocations = this.getAllLocations();
    const chosenEnrollment =
      allLocations.length > this.state.chosenLocationIndex
        ? allLocations[this.state.chosenLocationIndex]
        : null;

    // Disabling alert banner for now. This will be added back once program pages in claims also contain this header
    // let updateBankAndTaxText = "";
    // if (chosenEnrollment && chosenEnrollment.showUpdateBank && chosenEnrollment.showUpdateTax) {
    //     updateBankAndTaxText = localization.strings["TableStatusUpdateBankAndTaxProfile"];
    // } else if (chosenEnrollment && chosenEnrollment.showUpdateBank) {
    //     updateBankAndTaxText = localization.strings["TableStatusUpdateBankProfile"];
    // } else if (chosenEnrollment && chosenEnrollment.showUpdateTax) {
    //     updateBankAndTaxText = localization.strings["TableStatusUpdateTaxProfile"];
    // }

    return (
      <>
        {chosenEnrollment && (
          <div className="offering-page">
            {/*(chosenEnrollment.showUpdateBank || chosenEnrollment.showUpdateTax) && (
                            <div className="alert-band">
                                <div className="alert with-icon alert-warning" role="alert">
                                    <div className="row">
                                        <div className="col-xs-24">
                                            <p>
                                                <span className="win-icon win-icon-Warning" />
                                                &nbsp;{localization.strings["TableStatusActionRequired"]}&nbsp;
                                                <a href="#">{updateBankAndTaxText}</a>
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )*/}
            <div className="row">
              <div className="col-xs-24 col-sm-24">
                <Header>{chosenEnrollment.programName}</Header>
              </div>
            </div>
            <div className="row">
              <div className="col-xs-24 col-sm-24">
                <div className="dropdown">
                  <button
                    id="locationPicker"
                    className="btn btn-dropdown no-outline"
                    type="button"
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                    role="button"
                  >
                    {this.getLocationString(chosenEnrollment)}
                    <span className="caret" />
                  </button>

                  <ul
                    className="dropdown-menu"
                    role="menu"
                    aria-labelledby="locationPicker"
                  >
                    {allLocations.map((l, i) => (
                      <li
                        className={
                          i === this.state.chosenLocationIndex ? "active" : ""
                        }
                        key={i}
                        onClick={() => this.setChosenLocation(i)}
                      >
                        <a>{this.getLocationString(l)}</a>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>
            <IndeterminateProgressBar hidden={this.props.fetchedData} />
            <div className="spacer-md-bottom" />
            {/* {Environment.isModern() &&
                            this.props.fetchedData && (
                                <div className="row grid-view">
                                    <Card
                                        title={localization.strings["TableTotalEarnedHeader"]}
                                        amount={`${chosenEnrollment.currencyCode} ${
                                            chosenEnrollment.totalEarned
                                                ? chosenEnrollment.totalEarned.toLocaleString()
                                                : 0
                                        }`}
                                        linkText={localization.strings["TileViewEarnings"]}
                                        link="javascript:void(0)"
                                        isLtr={localization.ltr}
                                    />
                                    <Card
                                        title={localization.strings["TableTotalPaidHeader"]}
                                        amount={`${chosenEnrollment.currencyCode} ${
                                            chosenEnrollment.totalPaid ? chosenEnrollment.totalPaid.toLocaleString() : 0
                                        }`}
                                        linkText={localization.strings["TileViewPaymentStatements"]}
                                        link="javascript:void(0)"
                                        isLtr={localization.ltr}
                                    />
                                </div>
                            )} */}
            <div className="spacer-md-bottom" />
            Program resources
            <div className="spacer-xs-bottom" />
            {this.props.fetchedData &&
              this.renderProgramResourcesTable(chosenEnrollment, localization)}
          </div>
        )}
      </>
    );
  }

  private setChosenLocation(index: number) {
    this.setState({
      ...this.state,
      chosenLocationIndex: index,
    });
  }

  private getAllLocations(): EnrollmentDetail[] {
    return this.props.enrollments.filter(
      (e) => e.offeringId === this.props.offeringId
    );
  }

  private getLocationString(enrollment: EnrollmentDetail): string {
    return `${enrollment.locationName} (${enrollment.partnerId.value})`;
  }

  private renderProgramResourcesTable(
    detail: EnrollmentDetail,
    localization: LocalizationInfo
  ): JSX.Element {
    return detail.programGuide ? (
      <FullRow className="enrollments-table">
        <table className="data-table table">
          <thead>
            <tr>
              <th>
                {
                  localization.strings[
                    "OfferingProgramResourcesTableFileNameHeader"
                  ]
                }
              </th>
              <th>
                {
                  localization.strings[
                    "OfferingProgramResourcesTableDateModifiedHeader"
                  ]
                }
              </th>
              <th>
                {
                  localization.strings[
                    "OfferingProgramResourcesTableActionsHeader"
                  ]
                }
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>{localization.strings["ProgramGuide"]}</td>
              <td>
                {this.getLocalizedDate(detail.programGuide.modifiedDateTime)}
              </td>
              <td>
                <a target="_blank" href={detail.programGuide.path}>
                  {localization.strings["OfferingProgramResourcesDownloadLink"]}
                </a>
              </td>
            </tr>
          </tbody>
        </table>
      </FullRow>
    ) : (
      <></>
    );
  }

  private getLocalizedDate(date: string): string {
    try {
      var dateObj = new Date(date);
      return dateObj.toLocaleDateString(userLocale, dateOnlyOptions);
    } catch {
      return new Date(date).toLocaleDateString();
    }
  }
}
